export default __webpack_public_path__ + "static/media/slider-about@2x.711246a3.png";